module.exports = __webpack_public_path__ + "static/media/pencilMenu.960d7d2e.svg";